import { Box, Stack, Typography } from "@mui/material";

const LiveBadge = () => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        position: "absolute",
        top: "24px",
        left: "30px",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "22px",
          height: "22px",
          bgcolor: "#ff0037",
          borderRadius: "11px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "5px",
            left: "5px",
            width: "12px",
            height: "12px",
            bgcolor: "background.paper",
            borderRadius: "6px",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "7px",
            left: "7px",
            width: "8px",
            height: "8px",
            bgcolor: "#ff0037",
            borderRadius: "4px",
          }}
        />
      </Box>
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 400,
          fontSize: "20px",
          color: "white",
        }}
      >
        Live
      </Typography>
    </Stack>
  );
};

export default LiveBadge;
